import CloseIcon from "../../../../../assets/svgs/close.svg";
import styles from "./AddPatient.module.scss";

const ValidationADT = ({ selectedItem, close, hideHeader, isRedText = true, isMainHeader = true }) => {
    const { errors } = selectedItem;

    // Only show non-future date errors in this modal
    const displayErrors = errors?.filter(error =>
        !error.includes('is a future date. Please confirm to proceed.')
    ) || [];

    return (
        <div className={styles.validationADT}>
            <div className={styles.validationADTOverlay}></div>
            <div className={styles.validationADTContent}>
                <div className={`df aic ${styles.hdr}`}>
                    {isMainHeader && <p className={`df aic ffmm fs16`}>Validation Error</p>}
                    <div className={`mla`}>
                        <div className={`df acc ${styles.closeBtn}`} onClick={() => close()}>
                            <CloseIcon />
                        </div>
                    </div>
                </div>
                <div className={`p-t-8 p-r-20 p-b-20 p-l-20 df ffc ${styles.stepThree}`}>
                    {!hideHeader && <b>Please fill following required fields.</b>}

                    <ui className={`m-t-10 ${styles.errorList} ${isRedText ? styles.redTextList : ''}`}>
                        {displayErrors.map((item, index) => (
                            <li key={index}>
                                <span>{item}</span>
                            </li>
                        ))}
                    </ui>
                </div>
            </div>
        </div>
    );
};

export default ValidationADT;
